import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";

type VentanitaProps = {
  title: string;
  body: string | JSX.Element;
  buttonText: string;
  onClose?: () => void;
};

const Ventanita: React.FC<VentanitaProps> = ({
  title,
  body,
  buttonText,
  onClose
}) => {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    onClose?.();
    setShow(false);
  };
  return (
    <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false}>
      <Modal.Header className={"align-item-center"} closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{body}</Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Ventanita;
